<script setup lang="ts">
import { getCountryDomain } from '@/utils/routers'
import { SEOMaker } from '@/utils/seoMaker'

import { useNuxtApi } from '@/composables/useNuxtApi'

import HtmlContent from '@/components/Flatpages/HtmlContent.vue'

import { DEFAULT_SLUG_DATA, SLUG_PAGE_DATA } from '@@/constants/confidential'
import type { ConfidentialData } from '@@/server/types/common'

const { $host } = useNuxtApp()
const route = useRoute()

const cityDataForCurrentDomain = computed(() => {
  const { $host } = useNuxtApp()
  const countryDomain = getCountryDomain($host)

  return (
    SLUG_PAGE_DATA[countryDomain as keyof typeof SLUG_PAGE_DATA] ||
    DEFAULT_SLUG_DATA
  )
})

const pageTitle = computed(
  () => cityDataForCurrentDomain.value?.title || 'Farfor',
)

const { data: fetchedData } = await useNuxtApi<ConfidentialData>(
  '/api/flatpages',
  {
    query: {
      city: cityDataForCurrentDomain.value?.city,
      path: '/confidential/',
    },
  },
)

const breadcrumbs = computed(() => {
  return [
    { text: `Главная`, href: '/' },
    { text: 'Политика конфиденциальности', href: '/confidential' },
  ]
})

const confidentialPageContent = computed(() => fetchedData.value?.content || '')

useHead({
  title: pageTitle.value,
  ...SEOMaker(
    $host,
    {
      title: pageTitle.value,
      keywords: '',
      description: cityDataForCurrentDomain.value?.description || '',
    },
    route.fullPath,
  ),
})
</script>

<template>
  <div class="privacy-policy">
    <the-breadcrumbs
      class="privacy-policy__breadcrumbs"
      theme="dark"
      :domain="$host"
      :breadcrumbs="breadcrumbs"
    />

    <html-content :page-content="confidentialPageContent" />
  </div>
</template>

<style scoped lang="scss">
.privacy-policy {
  padding: 42px 20px 40px 20px;

  @include media($bp-tablet) {
    padding: 60px 20px 40px 20px;
  }

  @include media($bp-desktop-mini) {
    padding: 80px 0 100px 0;
  }

  &__breadcrumbs {
    margin-bottom: 20px;
  }
}
</style>
